import VueRouter from 'vue-router';

import constants from '@/utils/constants';
import storeHelpers from '@/store/helpers';

// pages
import home from './home';
import approval from './approval';
import overtime from './overtime';
import user from './user';
import settings from './settings';
import timesheet from './timesheet';
import requests from './requests';
import officialBusiness from './officialBusiness';
import reports from './reports';
import admin from './admin';
import errors from './errors';

const { obj: { BASE_URL } } = constants;
const appendBaseURL = path => `${BASE_URL}${path}`;
const removeMultiSlash = str => String(str).replace(/\/{2,}/, '/');
const prepareRoutes = routes => routes.map(route => ({
  ...route,
  path: removeMultiSlash(appendBaseURL(route.path)),
}));
const routes = [
  ...prepareRoutes(officialBusiness),
  ...prepareRoutes(requests),
  ...prepareRoutes(overtime),
  ...prepareRoutes(approval),
  ...prepareRoutes(home),
  ...prepareRoutes(user),
  ...prepareRoutes(settings),
  ...prepareRoutes(admin),
  ...prepareRoutes(timesheet),
  ...prepareRoutes(reports),
  ...prepareRoutes(errors),
  {
    path: '*',
    redirect: { name: 'error.404' },
  },
];

const AppRouter = new VueRouter({ routes, mode: 'history' });

AppRouter.beforeEach((to, from, next) => {
  if (to.matched.some(record => record.meta.requiresAuth)) {
    // get token from state
    const token = storeHelpers.getFromLocal('token');

    // has token
    if (typeof token === 'string') {
      // if root admin and home page
      const isRoot = storeHelpers.getFromLocal('isRoot');
      if (isRoot && to.name === 'home') {
        next({ name: 'maintenance' });
        return;
      }

      // redirect to password page if not yet done with initial password change
      const initPassword = storeHelpers.getFromLocal('initPassword');
      if (!initPassword && to.name !== 'user.password') {
        next({ name: 'user.password' });
        return;
      }
      // redirect to for approval page if approver with no requests enabled
      const isApproverNoRequest = storeHelpers.getFromLocal('isApproverNoRequest');
      if (isApproverNoRequest && to.name === 'home') {
        next({ name: 'for-approval' });
        return;
      }

      // get page permissions
      const { permissions: pagePermissions } = to.meta;
      // check user permissions against page required permissions
      if (Array.isArray(pagePermissions) && pagePermissions.length > 0) {
        const { permissions: userPermissions } = storeHelpers.getFromLocal('user', true);
        // user must have at least 1 permission required by the page/route
        if (
          pagePermissions
            .some(perm => (userPermissions || []).map(p => p.permission).includes(perm))
        ) {
          next();
        } else {
          // if admin and home page
          const isAdmin = storeHelpers.getFromLocal('isAdmin');
          if (isAdmin && to.name === 'home') {
            next({ name: 'audit-log' });
            return;
          }

          // return error forbidden
          next({ name: 'error.403', params: { errorMessage: 'You are forbidden to access this page' } });
        }
      } else {
        // no page permissions required
        next();
      }
    } else {
      let query = null;

      if (to.path !== BASE_URL) {
        query = { returnUrl: to.path };
      }
      // doesnt have token
      next({
        query,
        name: 'login',
        // return to target url after login
        params: to.params,
      });
    }
  } else {
    next();
  }
});

export default AppRouter;
